import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function WalmartDisconnectConfirmModal({
  open,
  onOpenChange,
  onDisconnected,
}) {
  const [submitting, setSubmitting] = useState(false);

  async function confirmDisconnect() {
    setSubmitting(true);
    try {
      await api.walmartDisconnect();
      toast.success("Walmart Seller Central disconnected.");
      onDisconnected?.();
    } catch {
      toast.error("Could not disconnect Walmart");
    } finally {
      setSubmitting(false);
    }
  }

  if (!open) return null;

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-[92]" />
        <Dialog.Content
          className="integration-modal fixed left-1/2 top-1/2 z-[93] w-[min(480px,calc(100vw-24px))] -translate-x-1/2 -translate-y-1/2 bg-white rounded-panel border border-edge-subtle shadow-menu p-5"
          data-testid="walmart-disconnect-confirm-modal"
        >
          <div className="flex items-start justify-between gap-3 mb-3">
            <Dialog.Title className="text-stitle text-ink-primary">
              Disconnect Walmart Seller Central?
            </Dialog.Title>
            <Dialog.Close className="p-1 rounded-ctrl hover:bg-surface-2">
              <X className="h-4 w-4" />
            </Dialog.Close>
          </div>
          <Dialog.Description asChild>
            <div className="text-compact text-ink-secondary space-y-2">
              <p>
                Ezisell will stop syncing Walmart marketplace data for this workspace.
              </p>
              <p>Existing historical research data will remain available.</p>
            </div>
          </Dialog.Description>
          <div className="integration-modal__footer flex flex-col-reverse sm:flex-row justify-end gap-2 mt-5">
            <button
              type="button"
              className="h-9 px-3 rounded-ctrl border border-edge-subtle text-compact"
              onClick={() => onOpenChange(false)}
              data-testid="walmart-disconnect-keep"
            >
              Keep connected
            </button>
            <button
              type="button"
              className="h-9 px-3 rounded-ctrl bg-red-600 text-white text-compact disabled:opacity-50"
              disabled={submitting}
              onClick={confirmDisconnect}
              data-testid="walmart-disconnect-confirm"
            >
              {submitting ? "Disconnecting…" : "Disconnect Walmart"}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
